<template>
  
  <div class="nav-wrapper">
    <div class="experience-container">
    <div class="form-section">
      <div class="business-form">
        <BackButton @back="$emit('back')" />
        <h1 class="main-title">{{ $t('businessEmployees.title') }}</h1>

        <div class="experience-options">
          <label class="experience-option" :class="{ 'selected': employeeCount === 'none' }">
            <input type="radio" v-model="employeeCount" value="none" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessEmployees.options.none') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': employeeCount === 'few' }">
            <input type="radio" v-model="employeeCount" value="few" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessEmployees.options.few') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': employeeCount === 'many' }">
            <input type="radio" v-model="employeeCount" value="many" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessEmployees.options.many') }}</span>
          </label>
        </div>

        <button class="next-button" @click="handleNext">{{ $t('businessEmployees.next') }}</button>
        <button class="skip-button" @click="$emit('skip')">{{ $t('businessEmployees.skip') }}</button>
      </div>
    </div>
    <div class="image-section">
      <img src="@/assets/slider3.1.png" alt="Business Planning" class="main-image">
    </div>
  </div>
  </div>
</template>

<script>
import BackButton from './BackButton.vue'

export default {
  name: 'BusinessEmployees',
  components: {
    BackButton
  },
  data() {
    return {
      employeeCount: 'none',
    }
  },
  methods: {
    handleNext() {
      this.$emit('next', {
        employeeCount: this.employeeCount
      });
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';
</style> 